/**
 * @desc showUserInfo API 查看过户信息
 *
 */
import React from 'react';
import { Provider } from 'react-redux';
import store from '@@/store';
import ReactDOM from 'react-dom';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { Icon, Modal, Form } from 'antd';
import { Root } from './style';
import { dealValueShow } from '@/shared/functions';
const mapStateToProps = (rootState, ownProps) => ({
    _state: rootState.showTransferInfo,
});
class InfoDom extends React.Component {
    constructor(props) {
        super(props);
        // 预览图片
        this.prewImg = (url) => {
            this.setState({
                previewVisible: true,
                previewImage: url,
            });
        };
        // 预览图片
        this.hideModal = () => {
            this.setState({
                previewVisible: false,
            });
        };
        this.state = {
            visible: false,
            previewVisible: false,
            previewImage: '',
        };
    }
    // 弹窗的确认按钮
    handleModalChange() {
        dispatch.showTransferInfo.SET_STATE({
            modalVisible: false
        });
    }
    render() {
        const { checkTransferData, tradeSuccessTransferType, modalVisible } = this.props._state;
        const { previewVisible, previewImage } = this.state;
        return (<React.Fragment>
        <Modal title="过户信息" visible={modalVisible} onOk={this.handleModalChange} onCancel={this.handleModalChange} destroyOnClose={true} width={1018}>
          <Root>
            <Form>
              <Form.Item label="过户类型" labelCol={{ span: 2 }} wrapperCol={{ span: 20 }} labelAlign={'left'}>
                <span>{tradeSuccessTransferType && dealValueShow(tradeSuccessTransferType) == 10 ? '本市过户' : (dealValueShow(tradeSuccessTransferType) == 20 ? '外迁过户' : '--')}
                </span>
              </Form.Item>
              {checkTransferData && checkTransferData.length > 0 ?
            checkTransferData.map((item, index) => (<Form.Item key={index} label={item.desc}>
                      <div className="userinfo">
                        {item.picGroup.length > 0 ? item.picGroup.slice(0, 6).map((itm, i) => (
            // <img src={itm.url} key={i} className="userinfoIng"></img>
            <span key={i} className="coverImg">
                            <img src={itm.url} className="userinfoIng"/>
                            <span className="cover"><Icon type="eye" onClick={() => this.prewImg(itm.url)}/> </span>
                          </span>)) : <span className="noData">无</span>}
                      </div>
                    </Form.Item>)) : '无'}
            </Form>
          </Root>
        </Modal>
        <Modal visible={previewVisible} title={null} footer={null} onCancel={this.hideModal}>
          <img alt="example" style={{ width: '100%', height: '100%' }} src={previewImage}/>
        </Modal>
      </React.Fragment>);
    }
}
const transferInfoComPonent = Form.create({})(InfoDom);
const resetTransferInfo = connect(mapStateToProps, null, null, { forwardRef: true })(transferInfoComPonent);
let componentRef = '';
const createInfo = () => {
    const div = document.createElement('div');
    div.className = 'souche--transferInfo';
    document.body.appendChild(div);
    const component = (<Provider store={store}>
    {React.createElement(resetTransferInfo, {
        ref: (ref) => {
            componentRef = ref;
        },
    })}
  </Provider>);
    ReactDOM.render(component, div);
};
export default function showUserInfo(record) {
    if (!componentRef) {
        createInfo();
    }
    dispatch.showTransferInfo.checkTransInfo(record);
}
